import React, { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Navbar from "../../Components/Navbar";
import { fetchProfile } from "../../utils/fetchProfile";
import { dataStatModules } from "../../utils/constant";
import Cookies from "js-cookie";
import {
  Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TablePagination, Modal, Box, TextField, Button, IconButton,
  Tooltip, CircularProgress, Autocomplete,
} from "@mui/material";
import { Slide, toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import AddLineModal from "./components/AddLineModal";
import LineSearchBar from "./components/LineSearchBar";

import { TEAL, TEAL_LIGHT, GREEN, GREEN_DARK, modalStyle, thStyle } from "./constants";
import { BootstrapButton } from "./components/BootstrapButton";
import ConfirmModal from "./components/ConfirmModal";
import AddRowContextMenu from "./components/AddRowContextMenu";
import AddProductModal from "./components/AddProductModal";
import GenerateCatalogModal from "./components/GenerateCatalogModal";
import CatalogListPage from "./components/CatalogListPage";

const API = process.env.REACT_APP_API_URL;
const getToken = () => Cookies.get("access_token") || "";
const authHeaders = () => ({ "Content-Type": "application/json", Authorization: "Bearer " + getToken() });

const apiFetch = {
  get: async (path) => {
    const r = await fetch(`${API}${path}`, { headers: authHeaders() });
    const data = await r.json();
    if (!r.ok || data?.detail) throw new Error(data?.detail || `Error ${r.status}`);
    return data;
  },
  post: async (path, body) => {
    const r = await fetch(`${API}${path}`, { method: "POST", headers: authHeaders(), body: JSON.stringify(body) });
    const data = await r.json();
    if (!r.ok || data?.detail) throw new Error(data?.detail || `Error ${r.status}`);
    return data;
  },
  put: async (path, body) => {
    const r = await fetch(`${API}${path}`, { method: "PUT", headers: authHeaders(), body: JSON.stringify(body) });
    const data = await r.json();
    if (!r.ok || data?.detail) throw new Error(data?.detail || `Error ${r.status}`);
    return data;
  },
  delete: async (path) => {
    const r = await fetch(`${API}${path}`, { method: "DELETE", headers: authHeaders() });
    const data = await r.json();
    if (!r.ok || data?.detail) throw new Error(data?.detail || `Error ${r.status}`);
    return data;
  },
};

const T = { position: "top-right", autoClose: 4000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, theme: "light", transition: Slide };
const toastSuccess = (m) => toast.success(m, T);
const toastError = (m) => toast.error(m, T);

function useDebounce(value, delay = 400) {
  const [d, setD] = useState(value);
  useEffect(() => { const t = setTimeout(() => setD(value), delay); return () => clearTimeout(t); }, [value, delay]);
  return d;
}

function SearchBar({ value, onChange }) {
  return (
    <Autocomplete
      options={dataStatModules}
      getOptionLabel={(option) => option.label}
      value={dataStatModules.find((o) => o.value === value) || null}
      onChange={(_, newValue) => onChange(newValue)}
      renderInput={(params) => (
        <TextField {...params} label="Cari Kategori" size="small" style={{ width: 280 }} />
      )}
      isOptionEqualToValue={(option, val) => option.value === val.value}
      disableClearable
    />
  );
}

export default function SetupCatalogReport() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [dataProfile, setDataProfile] = useState([]);
  const [notAllowAccessPage, setNotAllowAccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const view = id ? "detail" : "list";
  const [searchBarValue, setSearchBarValue] = useState("setup-catalog-report");

  const [reports, setReports] = useState([]);
  const [selectedReport, setSelectedReport] = useState(null);
  const [generateOpen, setGenerateOpen] = useState(false);

  const [lines, setLines] = useState([]);
  const [loadingLines, setLoadingLines] = useState(false);
  const [refreshingLines, setRefreshingLines] = useState(false);
  const [pageLines, setPageLines] = useState(0);
  const [rowsPerPageLines, setRowsPerPageLines] = useState(25);
  const [totalLines, setTotalLines] = useState(0);
  const [selectedLine, setSelectedLine] = useState(null);
  const activeLineIdRef = useRef(null);
  const lineSearchBarRef = useRef(null);


  const [items, setItems] = useState([]);
  const [autoItems, setAutoItems] = useState([]);
  const [loadingAutoItems, setLoadingAutoItems] = useState(false);
  const [totalAutoItems, setTotalAutoItems] = useState(0);
  const [pageAutoItems, setPageAutoItems] = useState(0);
  const [loadingItems, setLoadingItems] = useState(false);
  const [refreshingItems, setRefreshingItems] = useState(false);
  const [pageItems, setPageItems] = useState(0);
  const [rowsPerPageItems, setRowsPerPageItems] = useState(25);
  const [totalItems, setTotalItems] = useState(0);

  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);

  const [modalAddLine, setModalAddLine] = useState(false);
  const [newLineDesc, setNewLineDesc] = useState("");
  const [addLineCtx, setAddLineCtx] = useState({});
  const [contextMenuAnchor, setContextMenuAnchor] = useState(null);
  const [modalAddProduct, setModalAddProduct] = useState(false);
  const [refreshingCustomFilter, setRefreshingCustomFilter] = useState(false);
  const [exportingLines, setExportingLines] = useState(false);

  const [modalCreateCatalog, setModalCreateCatalog] = useState(false);
  const [newCatalogName, setNewCatalogName] = useState("");
  const [creatingCatalog, setCreatingCatalog] = useState(false);

  const [confirm, setConfirm] = useState({
    open: false, title: "", message: "", warningText: "",
    infoText: "", onConfirm: null, confirmLabel: "Ya", confirmColor: null,
  });
  const closeConfirm = () => setConfirm((p) => ({ ...p, open: false }));

  const dragFromIdx = useRef(null);
  const dragToIdx = useRef(null);
  const [dragOverIdx, setDragOverIdx] = useState(null);
  const [isDragging, setIsDragging] = useState(false);

  const debouncedCatalogId = useDebounce(selectedReport?.catalog_id, 400);
  const debouncedLineId = useDebounce(selectedLine?.report_line_id, 400);
  const debouncedPageL = useDebounce(pageLines, 400);
  const debouncedSizeL = useDebounce(rowsPerPageLines, 400);
  const debouncedPageI = useDebounce(pageItems, 400);
  const debouncedSizeI = useDebounce(rowsPerPageItems, 400);
  const prevCatalogIdRef = useRef(null);
  const [appliedLineSearch, setAppliedLineSearch] = useState("");
  const prevLineSearchRef = useRef("");
  const location = useLocation();

  useEffect(() => {
    if (!location.state?.forceRefresh) return;
    navigate(location.pathname, { replace: true, state: {} });
    if (!selectedReport?.catalog_id) return;
    activeLineIdRef.current = null;
    setSelectedLine(null);
    setItems([]);
    fetchLines(selectedReport.catalog_id, pageLines, rowsPerPageLines, appliedLineSearch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state?.forceRefresh]);


  const fetchReports = useCallback(async () => {
    try {
      const r = await apiFetch.get("/api/v1/catalog-report/reports?size=200");
      const data = r?.data || [];
      setReports(data);
      return data;
    } catch {
      toastError("Gagal memuat daftar catalog");
      return [];
    }
  }, []);

  const fetchLines = useCallback(async (reportId, page, size, search = "") => {
    if (!reportId) return;
    setLoadingLines(true);
    try {
      let url = `/api/v1/catalog-report/report-lines?catalog_id=${reportId}&page=${page + 1}&size=${size}`;
      if (search && search.trim()) {
        url += `&column_operator=like&column_value=${encodeURIComponent(search.trim())}`;
      }
      const r = await apiFetch.get(url);
      const data = r?.data || [];
      setLines(data);
      setTotalLines(r?.pagination_info?.total || 0);
      if (data.length > 0 && !activeLineIdRef.current) {
        activeLineIdRef.current = data[0].report_line_id;
        fetchItemsById(data[0].report_line_id, 0, rowsPerPageItems);
      }
    } catch { toastError("Gagal memuat hierarchy"); }
    finally { setLoadingLines(false); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchItemsById = useCallback(async (lineId, page, size) => {
    if (!lineId) return;
    setLoadingItems(true);
    try {
      const r = await apiFetch.get(`/api/v1/catalog-report/report-items?report_line_id=${lineId}&page=${page + 1}&size=${size}`);
      setItems(r?.data || []);
      setTotalItems(r?.pagination_info?.total || 0);
    } catch { toastError("Gagal memuat produk"); }
    finally { setLoadingItems(false); }
  }, []);

  const fetchAutoItems = useCallback(async (line, page, size) => {
    if (!line || line.is_custom || line.level === "product") return;
    setLoadingAutoItems(true);
    try {
      let param = "";
      if (line.level === "category" && line.category_master_id) {
        param = `category_master_id=${line.category_master_id}`;
      } else if (line.level === "brand" && line.brand_master_id) {
        param = `brand_master_id=${line.brand_master_id}`;
      }
      if (!param) return;
      const r = await apiFetch.get(`/api/v1/product-master?${param}&page=${page + 1}&size=${size}`);
      setAutoItems(r?.data || []);
      setTotalAutoItems(r?.pagination_info?.total || 0);
    } catch { toastError("Gagal memuat produk auto"); }
    finally { setLoadingAutoItems(false); }
  }, []);

  useEffect(() => {
    const h = setTimeout(() => { fetchProfile(getToken(), setDataProfile, setNotAllowAccess, ["13", "14"]); }, 300);
    return () => clearTimeout(h);
  }, []);

  useEffect(() => {
    const h = setTimeout(() => {
      fetchReports();
      apiFetch.get("/api/v1/category-master?size=200").then((r) => setCategories(r?.data || [])).catch(() => { });
      apiFetch.get("/api/v1/brand-master?size=200").then((r) => setBrands(r?.data || [])).catch(() => { });
    }, 300);
    return () => clearTimeout(h);
  }, [fetchReports]);

  useEffect(() => {
    if (!id) return;
    if (reports.length === 0) return;

    const found = reports.find((r) => String(r.catalog_id) === String(id));
    if (found) {
      setSelectedReport(found);
    } else {
      fetchReports().then((fresh) => {
        const foundFresh = fresh.find((r) => String(r.catalog_id) === String(id));
        if (foundFresh) setSelectedReport(foundFresh);
        else navigate("/stat-module/setup-catalog-report", { replace: true });
      });
    }
  }, [id, reports, navigate, fetchReports]);

useEffect(() => {
    if (!debouncedCatalogId) return;
    const isNewReport = prevCatalogIdRef.current !== debouncedCatalogId;
    const isNewSearch = prevLineSearchRef.current !== appliedLineSearch;
    if (isNewReport || isNewSearch) {
      prevCatalogIdRef.current = debouncedCatalogId;
      prevLineSearchRef.current = appliedLineSearch;
      activeLineIdRef.current = null;
      setSelectedLine(null); setItems([]); setPageItems(0);
      setPageAutoItems(0); setAutoItems([]);
      if (pageLines !== 0) setPageLines(0);
      fetchLines(debouncedCatalogId, 0, debouncedSizeL, appliedLineSearch);
      return;
    }
    fetchLines(debouncedCatalogId, debouncedPageL, debouncedSizeL, appliedLineSearch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedCatalogId, debouncedPageL, debouncedSizeL, appliedLineSearch, fetchLines, pageLines]);


  useEffect(() => {
    if (!debouncedLineId) return;
    activeLineIdRef.current = debouncedLineId;
    setPageItems(0);
    setPageAutoItems(0);
    setAutoItems([]);

    const line = lines.find(l => l.report_line_id === debouncedLineId);
    if (!line) return;

    if (line.is_custom) {
      fetchItemsById(debouncedLineId, 0, debouncedSizeI);
    } else {
      setItems([]);
      if (line.level !== "product") {
        fetchAutoItems(line, 0, debouncedSizeI);
      }
    }
  }, [debouncedLineId, debouncedSizeI, fetchItemsById, fetchAutoItems, lines]);

  useEffect(() => {
    if (!activeLineIdRef.current) return;
    const line = lines.find(l => l.report_line_id === activeLineIdRef.current);
    if (!line) return;

    if (line.is_custom) {
      fetchItemsById(activeLineIdRef.current, debouncedPageI, debouncedSizeI);
    } else if (line.level !== "product") {
      fetchAutoItems(line, pageAutoItems, debouncedSizeI);
    }
  }, [debouncedPageI, debouncedSizeI, fetchItemsById, fetchAutoItems, lines, pageAutoItems]);

  const refreshLines = useCallback((keepActive = true) => {
    if (selectedReport?.catalog_id) {
      if (!keepActive) activeLineIdRef.current = null;
      fetchLines(selectedReport.catalog_id, pageLines, rowsPerPageLines, appliedLineSearch);
    }
    // eslint-disable-next-line
  }, [selectedReport?.catalog_id, pageLines, rowsPerPageLines, appliedLineSearch]);

  const refreshItems = useCallback(() => {
    if (activeLineIdRef.current) fetchItemsById(activeLineIdRef.current, pageItems, rowsPerPageItems);
  }, [fetchItemsById, pageItems, rowsPerPageItems]);

  const handleSelectCatalog = (reportId) => navigate(`/stat-module/setup-catalog-report/${reportId}`);

 const handleBackToList = () => {
    setSelectedReport(null); setLines([]); setItems([]);
    setPageItems(0); setPageAutoItems(0); setAutoItems([]);
    activeLineIdRef.current = null; prevCatalogIdRef.current = null;
    setAppliedLineSearch("");
    lineSearchBarRef.current?.reset();
    navigate("/stat-module/setup-catalog-report");
};

  const openCreateCatalog = () => { setNewCatalogName(""); setModalCreateCatalog(true); };
  const closeCreateCatalog = () => { setModalCreateCatalog(false); setNewCatalogName(""); };

  const handleCreateCatalog = async () => {
    if (!newCatalogName.trim()) return toastError("Nama catalog wajib diisi");
    setCreatingCatalog(true);
    try {
      await apiFetch.post("/api/v1/catalog-report/reports", { catalog_name: newCatalogName.trim() });
      toastSuccess("Catalog berhasil dibuat");
      closeCreateCatalog();
      fetchReports();
    } catch (e) { toastError(e?.message || "Gagal membuat catalog"); }
    finally { setCreatingCatalog(false); }
  };

  const openAddLineModal = (ctx = {}) => {
    setAddLineCtx(ctx); setNewLineDesc(""); setModalAddLine(true);
  };
  const closeAddLineModal = () => { setModalAddLine(false); setNewLineDesc(""); setAddLineCtx({}); };

  const handleCreateLine = async ({ desc, level, ctx }) => {
    setIsLoading(true);
    try {
      const body = { reportingline_desc: desc, level };
      const { position, anchorLine } = ctx || {};
      if ((position === "above" || position === "below") && anchorLine?.ord_id) {
        body.source_ord_id = anchorLine.ord_id;
        body.source_position = position === "above" ? "before" : "after";
      }
      const prevIds = new Set(lines.map(l => l.report_line_id));
      await apiFetch.post(`/api/v1/catalog-report/report-lines?catalog_id=${selectedReport.catalog_id}`, body);
      toastSuccess("Baris berhasil ditambahkan");

      const r = await apiFetch.get(`/api/v1/catalog-report/report-lines?catalog_id=${selectedReport.catalog_id}&page=1&size=${rowsPerPageLines}`);
      const freshLines = r?.data || [];
      setLines(freshLines);
      setTotalLines(r?.pagination_info?.total || 0);

      const newLine = freshLines.find(l => !prevIds.has(l.report_line_id));
      setModalAddLine(false);
      if (newLine) {
        setSelectedLine(newLine);
        activeLineIdRef.current = newLine.report_line_id;
        setItems([]);
        navigate(`/stat-module/setup-catalog-report/${selectedReport.catalog_id}/custom-filter/${newLine.report_line_id}`);
      }
    } catch { toastError("Gagal menambah baris"); }
    finally { setIsLoading(false); }
  };

  const handleDeleteLine = (line) => {
    setConfirm({
      open: true, title: "Hapus Baris?",
      message: `"${line.reportingline_desc?.trim()}" beserta semua produk akan dihapus permanen.`,
      warningText: "Tindakan ini tidak dapat dibatalkan.", infoText: "",
      confirmLabel: "Ya, Hapus", confirmColor: "#e53935",
      onConfirm: async () => {
        closeConfirm();
        try {
          await apiFetch.delete(`/api/v1/catalog-report/report-lines/${line.report_line_id}`);
          toastSuccess("Baris dihapus");
          if (activeLineIdRef.current === line.report_line_id) {
            activeLineIdRef.current = null; setSelectedLine(null); setItems([]);
          }
          refreshLines();
        } catch (e) { toastError(e?.message || "Gagal menghapus baris"); }
      },
    });
  };

  const handleMoveLine = async (line, direction) => {
    const idx = lines.findIndex((l) => l.report_line_id === line.report_line_id);
    const swapIdx = direction === "up" ? idx - 1 : idx + 1;
    if (swapIdx < 0 || swapIdx >= lines.length) return;
    setIsLoading(true);
    try {
      await apiFetch.put(`/api/v1/catalog-report/report-lines/${line.report_line_id}`, {
        reportingline_desc: line.reportingline_desc, target_ord_id: lines[swapIdx].ord_id,
      });
      toastSuccess("Urutan diperbarui"); refreshLines();
    } catch (e) { toastError(e?.message || "Gagal mengubah urutan"); }
    finally { setIsLoading(false); }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const from = dragFromIdx.current; const to = dragToIdx.current;
    setIsDragging(false); setDragOverIdx(null); dragFromIdx.current = null; dragToIdx.current = null;
    if (from === null || to === null || from === to) return;
    const movedLine = lines[from]; const targetLine = lines[to];
    if (!movedLine || !targetLine) return;
    setConfirm({
      open: true, title: "Ubah Urutan?",
      message: `Pindahkan "${movedLine.reportingline_desc?.trim()}" ke posisi ${to + 1}?`,
      warningText: "", infoText: "", confirmLabel: "Ya, Pindah", confirmColor: null,
      onConfirm: async () => {
        closeConfirm(); setIsLoading(true);
        try {
          await apiFetch.put(`/api/v1/catalog-report/report-lines/${movedLine.report_line_id}`, {
            reportingline_desc: movedLine.reportingline_desc, target_ord_id: targetLine.ord_id,
          });
          toastSuccess("Urutan diperbarui"); refreshLines();
        } catch (e) { toastError(e?.message || "Gagal mengubah urutan"); }
        finally { setIsLoading(false); }
      },
    });
  };

  const handleDeleteItem = (item) => {
    setConfirm({
      open: true, title: "Hapus Produk?",
      message: `"${item.product_name || item.product_code}" akan dihapus dari baris ini.`,
      warningText: "Tindakan ini tidak dapat dibatalkan.", infoText: "",
      confirmLabel: "Ya, Hapus", confirmColor: "#e53935",
      onConfirm: async () => {
        closeConfirm();
        try {
          await apiFetch.delete(`/api/v1/catalog-report/report-items/${item.item_id}`);
          toastSuccess("Produk dihapus"); refreshItems();
        } catch (e) { toastError(e?.message || "Gagal menghapus produk"); }
      },
    });
  };

  const handleRefreshCustomFilter = async () => {
    if (!selectedReport?.catalog_id) return;
    setRefreshingCustomFilter(true);
    try {
      await apiFetch.post(
        `/api/v1/catalog-report/${selectedReport.catalog_id}/catalog/custom/generate?delete_existing=false`,
        {}
      );
      toastSuccess("Custom filter berhasil di-refresh");
      refreshLines();
      refreshItems();
    } catch (e) {
      toastError(e?.message || "Gagal refresh custom filter");
    } finally {
      setRefreshingCustomFilter(false);
    }
  };

  const handleExportLines = async () => {
    if (!selectedReport?.catalog_id) return;
    setExportingLines(true);
    try {
      const r = await fetch(
        `${API}/api/v1/catalog-report/report-lines/export/${selectedReport.catalog_id}`,
        { method: "POST", headers: authHeaders() }
      );
      if (!r.ok) {
        let msg = `Error ${r.status}`;
        try {
          const errJson = await r.clone().json();
          if (errJson?.detail) msg = errJson.detail;
        } catch { }
        throw new Error(msg);
      }

      const blob = await r.blob();

      const sanitizedCatalogName = (selectedReport.catalog_name || `catalog-${selectedReport.catalog_id}`)
        .trim()
        .replace(/[\\/:*?"<>|]/g, "")
        .replace(/\s+/g, "_");

      const disposition = r.headers.get("content-disposition");
      let filename = `${sanitizedCatalogName}.xlsx`;
      if (disposition) {
        const match = disposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i);
        if (match?.[1]) filename = decodeURIComponent(match[1]);
      }

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      toastSuccess("File berhasil diunduh");
    } catch (e) {
      toastError(e?.message || "Gagal export report lines");
    } finally {
      setExportingLines(false);
    }
  };

  const handleBulkSubmit = async (productMasterIds) => {
    const lineId = activeLineIdRef.current;
    if (!lineId) throw new Error("Pilih baris hierarchy terlebih dahulu");
    await apiFetch.post(
      `/api/v1/catalog-report/report-items/bulk?report_line_id=${lineId}`,
      { product_master_ids: productMasterIds }
    );
    toastSuccess(`${productMasterIds.length} produk berhasil ditambahkan`);
    refreshItems();
  };

  const handleGenerateRefresh = useCallback(() => {
    refreshLines();
    refreshItems();
    toastSuccess("Data diperbarui");
  }, [refreshLines, refreshItems]);

  const activeLine = selectedLine || lines[0] || null;

  if (notAllowAccessPage) return (
    <div>
      <Navbar active="Stat Module" initial={dataProfile.initial} role_code={dataProfile.role_code} />
      <div style={{ padding: 24 }}>Anda tidak memiliki akses ke halaman ini.</div>
    </div>
  );

 const searchBarEl = (
  <SearchBar
    value={searchBarValue}
    onChange={(newValue) => {
      if (newValue) { setSearchBarValue(newValue.value); navigate(`/stat-module/${newValue.value}`); }
    }}
  />
);

  if (view === "list") {
    return (
      <div>
        <Navbar active="Stat Module" initial={dataProfile.initial} role_code={dataProfile.role_code} />
        <div style={{ padding: "1rem" }}>
          <CatalogListPage
            apiFetch={apiFetch}
            onSelectCatalog={handleSelectCatalog}
            onOpenGenerate={(reportId, reportName) => {
              setSelectedReport({ catalog_id: reportId, catalog_name: reportName });
              setGenerateOpen(true);
            }} onOpenCreate={openCreateCatalog}
            onRefresh={fetchReports}
            searchBarSlot={searchBarEl}
          />
        </div>

        <GenerateCatalogModal
          open={generateOpen}
          onClose={() => setGenerateOpen(false)}
          onDone={() => setGenerateOpen(false)}
          onRefresh={() => {
            if (selectedReport?.catalog_id) {
              navigate(`/stat-module/setup-catalog-report/${selectedReport.catalog_id}`);
            }
            fetchReports();
          }}
          authHeaders={authHeaders}
          reports={reports}
          initialReport={selectedReport}
        />

        <Modal open={modalCreateCatalog} onClose={closeCreateCatalog}>
          <Box sx={{ ...modalStyle, width: 440, p: 3.5 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{
                  width: 34, height: 34, borderRadius: 8,
                  background: TEAL_LIGHT, border: `1.5px solid ${TEAL}44`,
                  display: "flex", alignItems: "center", justifyContent: "center",
                }}>
                  <EditNoteIcon sx={{ fontSize: 18, color: TEAL }} />
                </div>
                <h3 style={{ margin: 0, fontSize: 15, fontWeight: 700 }}>Buat Catalog Baru</h3>
              </div>
              <IconButton size="small" onClick={closeCreateCatalog}><CloseIcon /></IconButton>
            </div>
            <TextField
              label="Nama Catalog" fullWidth
              value={newCatalogName}
              onChange={(e) => setNewCatalogName(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleCreateCatalog()}
              placeholder="contoh: Catalog Q1 2025"
              autoFocus size="small" sx={{ mb: 2.5 }}
            />
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
              <Button variant="outlined" onClick={closeCreateCatalog}
                sx={{ textTransform: "none", color: "#999", borderColor: "#ddd" }}>
                Batal
              </Button>
              <BootstrapButton onClick={handleCreateCatalog} disabled={creatingCatalog} sx={{ minWidth: 120 }}>
                {creatingCatalog ? <CircularProgress size={15} sx={{ color: "#fff" }} /> : "Buat Catalog"}
              </BootstrapButton>
            </div>
          </Box>
        </Modal>
      </div>
    );
  }

  return (
    <div>
      <Navbar active="Stat Module" initial={dataProfile.initial} role_code={dataProfile.role_code} />
      <div style={{ padding: "1rem" }}>

        <div style={{
          display: "flex", alignItems: "center", gap: 10,
          marginBottom: 16, flexWrap: "wrap", justifyContent: "space-between",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
            {searchBarEl}
            <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
              <span style={{ fontSize: 12, color: "#999", whiteSpace: "nowrap" }}>Catalog:</span>
              <div style={{
                display: "inline-flex", alignItems: "center", gap: 6,
                padding: "5px 12px", borderRadius: 7,
                background: TEAL_LIGHT, border: `1px solid #9FE1CB`,
                fontSize: 13, fontWeight: 600, color: "#085041", height: 32,
              }}>
                <EditNoteIcon sx={{ fontSize: 14, color: TEAL }} />
                {selectedReport?.catalog_name}
              </div>
            </div>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Button
              disableRipple
              variant="outlined"
              onClick={handleBackToList}
              startIcon={<ArrowBackIcon sx={{ fontSize: 14 }} />}
              sx={{
                height: 40,
                textTransform: "none",
                fontSize: 13,
                boxShadow: "none",
                borderColor: "#000",
                color: "#666",
                "&:hover": {
                  color: TEAL,
                  backgroundColor: TEAL_LIGHT,
                  boxShadow: "none",
                },
              }}
            >
              Daftar Catalog
            </Button>
          </div>
        </div>

        <div style={{ display: "flex", gap: 16, marginBottom: 20 }}>

          <Paper sx={{ flex: 1, border: "1.5px solid rgb(234,243,248)", borderRadius: 2 }}>
            <div style={{
              padding: "10px 16px", borderBottom: "1px solid #f0f0f0",
              display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8,
            }}>
              <span style={{ fontWeight: 600, fontSize: 14, whiteSpace: "nowrap" }}>
                Hierarchy — {selectedReport?.catalog_name}
              </span>
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <LineSearchBar
                  ref={lineSearchBarRef}
                  onApply={(query) => setAppliedLineSearch(query)}
                  onClear={() => setAppliedLineSearch("")}
                />
                <Tooltip title="Download data hierarchy sebagai file Excel">
                  <span>
                    <Button
                      size="small"
                      disableRipple
                      disabled={exportingLines}
                      onClick={handleExportLines}
                      startIcon={
                        exportingLines
                          ? <CircularProgress size={14} sx={{ color: "#1D6F42" }} />
                          : <FileDownloadIcon fontSize="small" />
                      }
                      sx={{
                        textTransform: "none",
                        fontSize: 12,
                        fontWeight: 600,
                        py: 0.4, px: 1.2,
                        minWidth: "unset",
                        whiteSpace: "nowrap",
                        borderRadius: "6px",
                        border: "1px solid #1D6F42",
                        color: "#1D6F42",
                        "&:hover": { backgroundColor: "#E6F4EA", borderColor: "#1D6F42" },
                      }}
                    >
                      Download Excel
                    </Button>
                  </span>
                </Tooltip>
                <span style={{ fontSize: 12, color: "#bbb", whiteSpace: "nowrap" }}>
                  {totalLines} baris
                </span>
              </div>
            </div>
            <TableContainer>
              <Table size="small" sx={{ border: 1, borderColor: "grey.300", borderCollapse: "collapse" }}>
                <TableHead>
                  <TableRow>
                    <TableCell style={thStyle} align="center" width={32} />
                    <TableCell style={thStyle} align="center" width={44}>Order ID</TableCell>
                    <TableCell style={thStyle}>Reportingline</TableCell>
                    <TableCell style={thStyle}>Tipe</TableCell>
                    <TableCell style={thStyle}>Level</TableCell>
                    <TableCell style={thStyle} align="center" width={140}>Aksi</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loadingLines ? (
                    <TableRow><TableCell colSpan={6} align="center" sx={{ py: 4, border: 1, borderColor: "grey.300" }}><CircularProgress size={26} sx={{ color: TEAL }} /></TableCell></TableRow>
                  ) : lines.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={6} align="center" sx={{ py: 4, color: "#bbb", border: 1, borderColor: "grey.300" }}>
                        {appliedLineSearch.trim()
                          ? `Tidak ada hasil untuk "${appliedLineSearch.trim()}"`
                          : "Belum ada baris."}
                      </TableCell>
                    </TableRow>
                  ) : lines.map((line, originalIdx) => {
                    const isActive = activeLine?.report_line_id === line.report_line_id;
                    const isDragOver = dragOverIdx === originalIdx;
                    return (
                      <TableRow
                        key={line.report_line_id} hover
                        onClick={() => { setSelectedLine(line); activeLineIdRef.current = line.report_line_id; }}
                        draggable
                        onDragStart={() => { dragFromIdx.current = originalIdx; setIsDragging(true); }}
                        onDragEnter={(e) => { e.preventDefault(); dragToIdx.current = originalIdx; setDragOverIdx(originalIdx); }}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={handleDrop}
                        onDragEnd={() => { setIsDragging(false); setDragOverIdx(null); dragFromIdx.current = null; dragToIdx.current = null; }}
                        sx={{
                          cursor: isDragging ? "grabbing" : "pointer",
                          borderLeft: isActive ? `3px solid ${TEAL}` : "3px solid transparent",
                          borderTop: isDragOver ? `2px dashed ${TEAL}` : undefined,
                          color: line.is_custom ? "#fff" : undefined,
                          backgroundColor: isDragOver
                            ? "#e1f5ee66"
                            : isActive && line.is_custom
                              ? "#e3f2fd"
                              : isActive
                                ? "#90caf9"
                                : line.is_custom
                                  ? "#e1f5ee"
                                  : undefined,
                          opacity: isDragging && dragFromIdx.current === originalIdx ? 0.5 : 1,
                        }}
                      >
                        <TableCell align="center" sx={{ py: 0.5, color: "#ccc", cursor: "grab", border: 1, borderColor: "grey.300" }} />
                        <TableCell align="center" sx={{ py: 0.5, fontFamily: "monospace", fontSize: 12, color: "#bbb", border: 1, borderColor: "grey.300" }}>
                          {line.ord_id}
                        </TableCell>
                        <TableCell sx={{ py: 0.5, fontSize: 13, border: 1, borderColor: "grey.300" }}>
                          {appliedLineSearch.trim()
                            ? (() => {
                              const desc = line.reportingline_desc || "";
                              const lower = desc.toLowerCase();
                              const query = appliedLineSearch.trim().toLowerCase();
                              const matchIdx = lower.indexOf(query);
                              if (matchIdx === -1) return <div style={{ whiteSpace: "pre" }}>{desc}</div>;
                              return (
                                <div style={{ whiteSpace: "pre" }}>
                                  {desc.slice(0, matchIdx)}
                                  <mark style={{ backgroundColor: "#fff3a3", borderRadius: 2, padding: "0 1px" }}>
                                    {desc.slice(matchIdx, matchIdx + query.length)}
                                  </mark>
                                  {desc.slice(matchIdx + query.length)}
                                </div>
                              );
                            })()
                            : <div style={{ whiteSpace: "pre" }}>{line.reportingline_desc}</div>
                          }
                        </TableCell>
                        <TableCell sx={{ py: 0.5, fontSize: 13, border: 1, borderColor: "grey.300" }}>
                          <div>{line.is_custom ? "Custom" : "Auto"}</div>
                        </TableCell>
                        <TableCell sx={{ py: 0.5, fontSize: 13, border: 1, borderColor: "grey.300" }}>
                          <div>{line.level}</div>
                        </TableCell>
                        <TableCell align="center" sx={{ py: 0.5, border: 1, borderColor: "grey.300" }} onClick={(e) => e.stopPropagation()}>
                          <div style={{ display: "flex", justifyContent: "center" }}>
                            <Tooltip title={!line.is_custom ? "Tidak bisa dipindah (Auto)" : "Naik"}>
                              <span>
                                <IconButton size="small" disabled={originalIdx === 0 || isLoading || !line.is_custom} onClick={() => handleMoveLine(line, "up")}>
                                  <KeyboardArrowUpIcon fontSize="small" />
                                </IconButton>
                              </span>
                            </Tooltip>
                            <Tooltip title={!line.is_custom ? "Tidak bisa dipindah (Auto)" : "Turun"}>
                              <span>
                                <IconButton size="small" disabled={originalIdx === lines.length - 1 || isLoading || !line.is_custom} onClick={() => handleMoveLine(line, "down")}>
                                  <KeyboardArrowDownIcon fontSize="small" />
                                </IconButton>
                              </span>
                            </Tooltip>
                            <Tooltip title="Sisipkan baris">
                              <IconButton size="small" onClick={(e) => { e.stopPropagation(); setContextMenuAnchor({ el: e.currentTarget, line }); }}>
                                <AddIcon fontSize="small" sx={{ color: TEAL }} />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title={!line.is_custom ? "Tidak bisa dihapus (Auto)" : "Hapus"}>
                              <span>
                                <IconButton size="small" disabled={!line.is_custom} onClick={() => handleDeleteLine(line)} sx={{ color: !line.is_custom ? undefined : "#e53935" }}>
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </span>
                            </Tooltip>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50]} component="div"
              count={totalLines} rowsPerPage={rowsPerPageLines} page={pageLines}
              onPageChange={(_, p) => {
                setAppliedLineSearch("");
                lineSearchBarRef.current?.reset();
                setPageLines(p);
              }}
              onRowsPerPageChange={(e) => { setRowsPerPageLines(parseInt(e.target.value, 10)); setPageLines(0); }}
            />
          </Paper>

          <Paper sx={{ flex: 1, border: "1.5px solid rgb(234,243,248)", borderRadius: 2 }}>
            <div style={{
              padding: "10px 16px", borderBottom: "1px solid #f0f0f0",
              display: "flex", justifyContent: "space-between", alignItems: "center",
            }}>
              <span style={{ fontWeight: 600, fontSize: 14 }}>
                Produk {activeLine ? `— ${activeLine.reportingline_desc?.trim()}` : ""}
              </span>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontSize: 12, color: "#bbb" }}>{totalItems} produk</span>
                {/* {activeLine && (
                  <Tooltip title={!activeLine.is_custom ? "Baris Auto — produk dikelola otomatis oleh sistem" : ""}>
                    <span>
                      <BootstrapButton disableRipple
                        disabled={!activeLine.is_custom}
                        sx={{
                          py: 0.4, px: 1.5, fontSize: 12, minWidth: "unset",
                          whiteSpace: "nowrap",
                          color: "#fff",
                          ...((!activeLine.is_custom) && {
                            backgroundColor: "#e5e7eb",
                            color: "#9ca3af",
                            cursor: "not-allowed",
                            pointerEvents: "none",
                          }),
                        }}
                        onClick={() => setModalAddProduct(true)}>
                        + Tambah Produk
                      </BootstrapButton>
                    </span>
                  </Tooltip>
                )} */}
                <Tooltip title={!activeLine?.is_custom ? "Baris Auto — custom filter tidak berlaku" : ""}>
                  <span>
                    <BootstrapButton
                      disableRipple
                      disabled={refreshingCustomFilter || !activeLine?.is_custom}
                      onClick={handleRefreshCustomFilter}
                      sx={{
                        py: 0.4, px: 1.5, fontSize: 12, minWidth: "unset",
                        whiteSpace: "nowrap",
                        color: "#fff",
                        ...(!activeLine?.is_custom && {
                          backgroundColor: "#e5e7eb",
                          color: "#9ca3af",
                          cursor: "not-allowed",
                          pointerEvents: "none",
                        }),
                      }}
                    >
                      {refreshingCustomFilter ? <CircularProgress size={14} sx={{ color: "#fff" }} /> : "Refresh Custom Filter"}
                    </BootstrapButton>
                  </span>
                </Tooltip>
                <Tooltip title={!activeLine?.is_custom ? "Baris Auto — custom filter tidak berlaku" : ""}>
                  <span>
                    <Button
                      variant="outlined"
                      size="small"
                      disableRipple
                      disabled={!activeLine?.is_custom}
                      onClick={() => navigate(`/stat-module/setup-catalog-report/${selectedReport.catalog_id}/custom-filter/${activeLine.report_line_id}`)}
                      sx={{
                        textTransform: "none",
                        fontSize: 12,
                        fontWeight: 600,
                        py: 0.4, px: 1.5,
                        minWidth: "unset",
                        whiteSpace: "nowrap",
                        borderRadius: "6px",
                        borderColor: TEAL,
                        color: TEAL,
                        "&:hover": { borderColor: TEAL, backgroundColor: TEAL_LIGHT },
                        ...(!activeLine?.is_custom && {
                          borderColor: "#e5e7eb",
                          color: "#9ca3af",
                          cursor: "not-allowed",
                          "&:hover": { borderColor: "#e5e7eb", backgroundColor: "transparent" },
                        }),
                      }}
                    >
                      Edit Custom Filter
                    </Button>
                  </span>
                </Tooltip>
              </div>
            </div>
            <TableContainer>
              <Table size="small" sx={{ border: 1, borderColor: "grey.300", borderCollapse: "collapse" }}>
                <TableHead>
                  <TableRow>
                    <TableCell style={thStyle} align="center" width={44}>No.</TableCell>
                    <TableCell style={thStyle}>Kode</TableCell>
                    <TableCell style={thStyle}>Nama Produk</TableCell>
                    <TableCell style={thStyle} align="center" width={72}>Aksi</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!activeLine ? (
                    <TableRow><TableCell colSpan={4} align="center" sx={{ py: 4, color: "#bbb", border: 1, borderColor: "grey.300" }}>Klik baris untuk melihat produk</TableCell></TableRow>
                  ) : !activeLine.is_custom && activeLine.level === "product" ? (
                    <TableRow>
                      <TableCell align="center" sx={{ fontFamily: "monospace", fontSize: 12, color: "#bbb", border: 1, borderColor: "grey.300" }}>1</TableCell>
                      <TableCell sx={{ fontFamily: "monospace", fontSize: 12, color: "#999", border: 1, borderColor: "grey.300" }}>
                        {activeLine.product_code || "—"}
                      </TableCell>
                      <TableCell sx={{ fontSize: 13, border: 1, borderColor: "grey.300" }}>
                        {activeLine.reportingline_desc?.trim() || "—"}
                      </TableCell>
                      <TableCell align="center" sx={{ border: 1, borderColor: "grey.300" }} />
                    </TableRow>
                  ) : !activeLine.is_custom ? (
                    loadingAutoItems ? (
                      <TableRow><TableCell colSpan={4} align="center" sx={{ py: 4, border: 1, borderColor: "grey.300" }}><CircularProgress size={26} sx={{ color: TEAL }} /></TableCell></TableRow>
                    ) : autoItems.length === 0 ? (
                      <TableRow><TableCell colSpan={4} align="center" sx={{ py: 4, color: "#bbb", border: 1, borderColor: "grey.300" }}>Tidak ada produk.</TableCell></TableRow>
                    ) : autoItems.map((item, idx) => (
                      <TableRow key={item.product_master_id || idx} hover>
                        <TableCell align="center" sx={{ fontFamily: "monospace", fontSize: 12, color: "#bbb", border: 1, borderColor: "grey.300" }}>
                          {pageAutoItems * rowsPerPageItems + idx + 1}
                        </TableCell>
                        <TableCell sx={{ fontFamily: "monospace", fontSize: 12, color: "#999", border: 1, borderColor: "grey.300" }}>
                          {item.product_id || "—"}
                        </TableCell>
                        <TableCell sx={{ fontSize: 13, border: 1, borderColor: "grey.300" }}>{item.product_name || item.name || "—"}</TableCell>
                        <TableCell align="center" sx={{ border: 1, borderColor: "grey.300" }} />
                      </TableRow>
                    ))
                  ) : loadingItems ? (
                    <TableRow><TableCell colSpan={4} align="center" sx={{ py: 4, border: 1, borderColor: "grey.300" }}><CircularProgress size={26} sx={{ color: TEAL }} /></TableCell></TableRow>
                  ) : items.length === 0 ? (
                    <TableRow><TableCell colSpan={4} align="center" sx={{ py: 4, color: "#bbb", border: 1, borderColor: "grey.300" }}>Belum ada produk.</TableCell></TableRow>
                  ) : items.map((item, idx) => (
                    <TableRow key={item.item_id || idx} hover>
                      <TableCell align="center" sx={{ fontFamily: "monospace", fontSize: 12, color: "#bbb", border: 1, borderColor: "grey.300" }}>
                        {pageItems * rowsPerPageItems + idx + 1}
                      </TableCell>
                      <TableCell sx={{ fontFamily: "monospace", fontSize: 12, color: "#999", border: 1, borderColor: "grey.300" }}>
                        {item.product_code || "—"}
                      </TableCell>
                      <TableCell sx={{ fontSize: 13, border: 1, borderColor: "grey.300" }}>{item.product_name || "—"}</TableCell>
                      <TableCell align="center" sx={{ border: 1, borderColor: "grey.300" }}>
                        <Tooltip title="Hapus">
                          <IconButton size="small" onClick={() => handleDeleteItem(item)} sx={{ color: "#e53935" }}>
                            <DeleteOutlineIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50]} component="div"
              count={activeLine?.is_custom === false && activeLine?.level !== "product" ? totalAutoItems : totalItems}
              rowsPerPage={rowsPerPageItems}
              page={activeLine?.is_custom === false && activeLine?.level !== "product" ? pageAutoItems : pageItems}
              onPageChange={(_, p) => {
                if (activeLine?.is_custom === false && activeLine?.level !== "product") {
                  setPageAutoItems(p);
                  const line = lines.find(l => l.report_line_id === activeLineIdRef.current);
                  if (line) fetchAutoItems(line, p, rowsPerPageItems);
                } else {
                  setPageItems(p);
                }
              }}
              onRowsPerPageChange={(e) => {
                const val = parseInt(e.target.value, 10);
                setRowsPerPageItems(val);
                setPageItems(0);
                setPageAutoItems(0);
              }}
            />
          </Paper>
        </div>
      </div>

      <GenerateCatalogModal
        open={generateOpen}
        onClose={() => setGenerateOpen(false)}
        onDone={() => setGenerateOpen(false)}
        onRefresh={handleGenerateRefresh}
        authHeaders={authHeaders}
        reports={reports}
        initialReport={selectedReport}
      />

      <AddProductModal
        open={modalAddProduct}
        onClose={() => setModalAddProduct(false)}
        onSubmit={handleBulkSubmit}
        lineName={activeLine?.reportingline_desc?.trim() || ""}
        catalogId={selectedReport?.catalog_id}
        authHeaders={authHeaders}
      />

      <AddLineModal
        open={modalAddLine}
        onClose={closeAddLineModal}
        onSubmit={handleCreateLine}
        ctx={addLineCtx}
        isLoading={isLoading}
      />

      <AddRowContextMenu
        anchorEl={contextMenuAnchor?.el || null}
        onClose={() => setContextMenuAnchor(null)}
        onSelectAbove={() => { openAddLineModal({ position: "above", anchorLine: contextMenuAnchor?.line }); setContextMenuAnchor(null); }}
        onSelectBelow={() => { openAddLineModal({ position: "below", anchorLine: contextMenuAnchor?.line }); setContextMenuAnchor(null); }}
      />

      <ConfirmModal
        open={confirm.open} title={confirm.title} message={confirm.message}
        warningText={confirm.warningText} infoText={confirm.infoText}
        onConfirm={confirm.onConfirm} onCancel={closeConfirm}
        loading={isLoading} confirmLabel={confirm.confirmLabel} confirmColor={confirm.confirmColor}
      />
    </div>
  );
}